import React, { useEffect, useMemo, useState } from "react";
import { get_distributors_status } from "../../../../api/endpoints/distributors";
import { Inner, Grid, Card, Circle, Label, Row, Controls } from "./styles";
import { COLORS, Typo } from "../../../layout/theme";
import { Segmented, Table } from "antd";
import { CONSTANTS } from "../../../../utils/constants";

export default function MarketDistributorStatus() {
	const [distributorStatusList, setDistributorStatusList] = useState([]);
	const [view, setView] = useState(CONSTANTS.VIEW_LIST);
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		const fetch_status = async () => {
			setLoading(true);
			try {
				const res = await get_distributors_status();
				setDistributorStatusList(res.distributors || []);
			} catch (error) {
			} finally {
				setLoading(false);
			}
		};

		fetch_status();
	}, []);

	const getColor = (status) => {
		switch (status) {
			case "OK":
				return COLORS.Success;
			case "Warning":
				return COLORS.Warning;
			case "Error":
				return COLORS.Danger;
			default:
				return COLORS.LightGrey;
		}
	};

	const columns = useMemo(
		() => [
			{
				title: "Droguería",
				dataIndex: "distributorName",
				key: "distributorName",
				sorter: (a, b) => a.distributorName.localeCompare(b.distributorName),
				render: (text) => <strong>{text}</strong>,
			},
			{
				title: "Envíos",
				dataIndex: "send",
				key: "send",
				filters: [
					{ text: "OK", value: "OK" },
					{ text: "Warning", value: "Warning" },
					{ text: "Error", value: "Error" },
				],
				onFilter: (value, record) => record.send === value,
				render: (val) => <Circle color={getColor(val)} />,
			},
			{
				title: "Respuestas",
				dataIndex: "response",
				key: "response",
				filters: [
					{ text: "OK", value: "OK" },
					{ text: "Warning", value: "Warning" },
					{ text: "Error", value: "Error" },
				],
				onFilter: (value, record) => record.response === value,
				render: (val) => <Circle color={getColor(val)} />,
			},
		],
		[]
	);

	return (
		<Inner>
			<Typo level={5} type="secondary">
				Estado de Servicios por Droguería
			</Typo>
			<Controls>
				<Segmented
					options={[CONSTANTS.VIEW_GRID, CONSTANTS.VIEW_LIST]}
					value={view}
					onChange={setView}
				/>
			</Controls>
			{view === CONSTANTS.VIEW_GRID ? (
				<Grid>
					{distributorStatusList &&
						distributorStatusList.map((dist) => (
							<Card key={dist.distributorId}>
								<Label>{dist.distributorName}</Label>
								<Row>
									<Circle color={getColor(dist.send)} />
									<span>Envíos</span>
								</Row>
								<Row>
									<Circle color={getColor(dist.response)} />
									<span>Respuestas</span>
								</Row>
							</Card>
						))}
				</Grid>
			) : (
				<Table
					loading={loading}
					rowKey="DistributorId"
					columns={columns}
					dataSource={distributorStatusList}
					pagination={{ pageSize: 25 }}
				/>
			)}
		</Inner>
	);
}
